module.exports = __webpack_public_path__ + "static/profile-65f11e0529547067df0e8b09cedfee18.png";